﻿export class Sounds {
    private static instances: Map<string, HTMLAudioElement> = new Map();

    static Beep(): void { Sounds.Play("/sounds/beep.mp3"); }
    
    /**
     * Play a sound from the given URL.
     * If the sound was already created, it will restart from the beginning.
     * @param url The URL of the audio file (e.g., "/sounds/notify.mp3")
     */
    static Play(url: string): void {
        
        try {
            let audio = this.instances.get(url);

            if (!audio) {
                audio = new Audio(url);
                this.instances.set(url, audio);
            } else {
                // Reset playback to start if already loaded
                audio.currentTime = 0;
            }

            // Attempt to play the audio, catching any autoplay restrictions
            audio
                .play()
                .catch(err => {
                    console.error(`Failed to play sound from ${url}:`, err);
                });
        }
        catch (e) {
            console.error(e);
        }
    }

    /**
     * Stop a currently playing sound.
     * @param url The URL of the audio file
     */
    static Stop(url: string): void {
        const audio = this.instances.get(url);
        if (audio) {
            audio.pause();
            audio.currentTime = 0;
        }
    }

    /**
     * Stop all playing sounds.
     */
    private static StopAll(): void {
        this.instances.forEach(audio => {
            audio.pause();
            audio.currentTime = 0;
        });
    }
}
